@import '../Field/field.css';
@import '../es-input/es-input.css';

::host {
    display: block;
}

.input {
    width: 100%;
}

.input_wrapper {
    position: relative;
    grid-column-start: input;
    grid-column-end: input;
}

.unit {
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    right: 20px;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
